/* eslint-disable @typescript-eslint/no-explicit-any */
import styles from './index.module.css';
import { checkedImg } from '../../assets/images/dashboard-business';

const Benefits = ({ benefits, label }: any) => {
  return (
    <div
      className={[styles.benefitsContainer, 'mt-7 sl:mt-0 sl:min-w-[200px] sl:h-[100%]'].join(' ')}
    >
      <div className={styles.benefitsSmallContainer}>
        <b className='text-sm'>{label}</b>
        <hr className='bg-[#768396] h-[1.23px] w-[80%]' />

        {benefits.map((benefit: any, index: number) => (
          <div className='mt-3 flex flex-row gap-1 items-start' key={benefit}>
            <img src={checkedImg} alt='checked' className='mt-[2px] mr-[2px]' />
            <div className='font-poppins text-[12px]'>{benefit}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
